import styled from '@emotion/styled';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';
import { Button } from '../Button';

export const CardItemProContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  /* overflow: hidden; */
`;

export const CardItemProWrapper = styled.div`
  /* height: 270px; */
  height: auto;
  margin: 20px 0;
  width: 100%;
  height: 100%;
  ${mediaQuery('tablet')} {
    width: 50%;
    height: auto;
  }
  ${mediaQuery('small')} {
    width: 100%;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${mediaQuery('tablet')} {
    flex-direction: column;
  }
`;

export const Image = styled.img`
  object-fit: cover;
  width: 200px;
  box-shadow: 0 0 10px 5px rgb(0 0 0 / 5%);
  border-radius: 10px;
  height: 80%;
  max-height: 150px;
  ${mediaQuery('tablet')} {
    max-height: auto;
    max-width: 350px;
    width: 80%;
  }
`;

export const Main = styled.div<{ hasImage: boolean }>`
  border-radius: 10px;
  box-shadow: 0 0 10px 5px rgb(0 0 0 / 5%);
  background: ${(props) => props.theme.color.light.default};
  padding: 25px 40px;
  margin-left: ${(props) => (props.hasImage ? '-20px' : '0px')};
  flex: 1;
  display: flex;
  width: ${(props) => (props.hasImage ? 'calc(100% - 180px)' : '100%')};
  overflow: hidden;
  ${mediaQuery('tablet')} {
    flex-direction: column;
    margin: -20px auto 0;
    padding: 25px;
    width: 95%;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% - 250px);

  ${mediaQuery('tablet')} {
    width: 100%;
    margin-bottom: 10px;
  }

  p {
    margin: 0;
  }
`;

export const Title = styled.div`
  color: ${(props) => props.theme.color.blue.default};
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
  ${responsiveFontSize(26, 3)}
  margin-bottom: '15px';
  ${mediaQuery('tablet')} {
    margin-bottom: 10px;
  }
`;

export const Description = styled.div`
  color: ${(props) => props.theme.color.medium.default};
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 5px;
  ${mediaQuery('header')} {
    display: none;
  }
  > *:not(:first-of-type) {
    display: none;
  }
`;

export const Services = styled.div`
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 5px;
  color: ${(props) => props.theme.color.medium.default};
`;

export const ServicesSpan = styled.span`
  color: ${(props) => props.theme.color.dark.default};
  font-weight: 600;
`;

export const SideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  max-width: 230px;
  justify-content: center;
  width: 100%;
  ${mediaQuery('small')} {
    margin: auto;
  }
`;

export const InfoWrapper = styled.div`
  margin-bottom: 10px;
  &:last-of-type {
    margin-bottom: 10px;
  }
  display: flex;
  align-items: center;
  line-height: 1.2;
  color: ${(props) => props.theme.color.medium.default};

  ${mediaQuery('tablet')} {
    font-size: 16px;
    margin-bottom: 5px;
  }
`;

export const DistanceText = styled.span`
  display: block;
  margin-top: 4px;
  font-weight: 600;
  font-size: 14px;
  width: 100%;
  color: ${(props) => props.theme.color.blue.default};
`;

export const InfoIcon = styled.div`
  width: 25px;
  margin-right: 10px;
  text-align: center;

  ${mediaQuery('tablet')} {
    width: 20px;
  }
`;

export const ReviewWrapper = styled.div`
  margin-bottom: 10px;
  &:last-of-type {
    margin-bottom: 10px;
  }
  display: flex;
  align-items: center;
  line-height: 1.2;
  color: ${(props) => props.theme.color.medium.default};

  ${mediaQuery('tablet')} {
    font-size: 16px;
    margin-bottom: 5px;
  }
`;

export const ReviewText = styled.div`
  font-size: 14px;
  margin-left: 4px;
  font-weight: 400;
`;
